
import { store } from "@/store";
import { dispatchProjectAccess } from "@/store/project/actions";
import { Options, Vue } from "vue-class-component";
@Options({
  components: {},
})
export default class Banner extends Vue {
  public bgUrl = require("../assets/banner/bg.jpg");
  public fulllinkUrl = require("../assets/banner/fulllink.jpg");
  public preciseUrl = require("../assets/banner/precise.jpg");
  public myData = new Date();
  public year = this.myData.getFullYear();

  public project_access() {
    (this as any)
      .$confirm("此操作将向平台负责人发送项目接入请求，是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        dispatchProjectAccess(store),
          (this as any).$message({
            type: "success",
            message: "项目接入请求已发送，请等待相关人员联系您。",
          });
      })
      .catch(() => {
        (this as any).$message({
          type: "info",
          message: "已取消",
        });
      });
  }
}
